<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      show-footer
      :footer-method="() => footerData"
      ref="goodsTable"
      row-id="shipmentBatchBoxGoodsCode"
      :checkbox-config="{ highlight: true }"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
      :expand-config="{ visibleMethod: expandVisible }"
      @cell-click="onCellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>

      <template v-slot:isGroup="{ row }">
        <el-tag size="mini" :type="row.isGroup === 'Y' ? 'light' : 'info'">
          {{ row.v_isGroup }}
        </el-tag>
      </template>
      <template v-slot:isUseGroupHsCode="{ row }">
        <el-tag
          size="mini"
          :type="row.isUseGroupHsCode === 'Y' ? 'info' : 'danger'"
        >
          {{ row.v_isUseGroupHsCode }}
        </el-tag>
      </template>
      <template v-slot:expandContent="{ row }">
        <div class="p-2" v-if="row.isGroup === 'Y'">
          <GoodsSpecTable
            ref="goodsSpecTable"
            :shipmentCode="row.shipmentCode"
            :orderGoodsCode="row.orderGoodsCode"
            :currencyUnit="row.v_currencyUnit"
            :salesCurrencyUnit="row.v_salesCurrencyUnit"
            disabled
          />
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="$emit('openEditDialog', row)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import GoodsSpecTable from '../goods-spec/table'
import { add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  components: { GoodsSpecTable },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData || !this.tableData.length) return [[]]

      const {
        totalInPackageQty = 0,
        totalInPackagePrice = 0,
        totalInPackageSalePrice = 0,
        totalInPackageNetWeight = 0,
      } = this.tableData.reduce(
        (result, next) => {
          result.totalInPackageQty = add(
            result.totalInPackageQty,
            next.totalInPackageQty
          )
          result.totalInPackagePrice = add(
            result.totalInPackagePrice,
            next.totalInPackagePrice
          )
          result.totalInPackageSalePrice = add(
            result.totalInPackageSalePrice,
            next.totalInPackageSalePrice
          )
          result.totalInPackageNetWeight = add(
            result.totalInPackageNetWeight,
            next.totalInPackageNetWeight
          )
          return result
        },
        {
          totalInPackageQty: 0,
          totalInPackagePrice: 0,
          totalInPackageSalePrice: 0,
          totalInPackageNetWeight: 0,
        }
      )
      const result = [
        this.$l('INDEX.total') || '合计',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        totalInPackageQty,
        '',
        totalInPackagePrice,
        totalInPackageSalePrice,
        totalInPackageNetWeight,
      ]
      if (this.disabled) {
        result.splice(1, 2)
      }

      return [result]
    },
  },
  watch: {
    footerData: {
      handler() {
        this.$refs.goodsTable.updateFooter()
      },
      deep: true,
    },
  },
  methods: {
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
    onCellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'expand', 'col-opt']
      if (filterColumns.includes(property)) return
      this.$refs.goodsTable.toggleCheckboxRow(row)

      const data = this.$refs.goodsTable.getCheckboxRecords(true)
      this.$emit('checkboxChange', data)
    },
    expandVisible({ row }) {
      return row.isGroup === 'Y'
    },
    specReload() {
      const $goodsSpecTable = this.$refs.goodsSpecTable
      if ($goodsSpecTable) $goodsSpecTable.getData()
    },
  },
}
</script>
